/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TopClassRow } from './TopClassRow';
import {
    TopClassRowFromJSON,
    TopClassRowFromJSONTyped,
    TopClassRowToJSON,
    TopClassRowToJSONTyped,
} from './TopClassRow';

/**
 * 
 * @export
 * @interface TopClassesWidgetData
 */
export interface TopClassesWidgetData {
    /**
     * 
     * @type {Array<TopClassRow>}
     * @memberof TopClassesWidgetData
     */
    items: Array<TopClassRow>;
}

/**
 * Check if a given object implements the TopClassesWidgetData interface.
 */
export function instanceOfTopClassesWidgetData(value: object): value is TopClassesWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function TopClassesWidgetDataFromJSON(json: any): TopClassesWidgetData {
    return TopClassesWidgetDataFromJSONTyped(json, false);
}

export function TopClassesWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TopClassesWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(TopClassRowFromJSON)),
    };
}

export function TopClassesWidgetDataToJSON(json: any): TopClassesWidgetData {
    return TopClassesWidgetDataToJSONTyped(json, false);
}

export function TopClassesWidgetDataToJSONTyped(value?: TopClassesWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(TopClassRowToJSON)),
    };
}

